import { EColors } from "common/styles"
import { Styled } from "components/Styled"
import { contacts } from "./data"
import { StyledContactItem, StyledContactsList, StyledPhone } from "./styled"


export const ContactsList = () => {
    return (
        <StyledContactsList>
            {contacts.map((contact, index: number) => (
                <StyledContactItem key={index}>
                    <Styled.PBody1 color={EColors.white}>{contact.city}</Styled.PBody1>
                    <StyledPhone>{contact.phone}</StyledPhone>
                </StyledContactItem>
            ))}

        </StyledContactsList>
    )
}